<template>
  <div class='home'>
    <PaymentMethodList
      v-show='listView'
      @newPaymentMethod='onClickNewFromList'
      @editPaymentMethod='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PaymentMethodForm
      v-show='formView'
      :paymentMethod='paymentMethod'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PaymentMethodList from '@/components/payment-method/PaymentMethodList.vue'
import PaymentMethodForm from '@/components/payment-method/PaymentMethodForm.vue'

export default {
  name: 'Payment_Method',
  components: {
    PaymentMethodList,
    PaymentMethodForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      paymentMethod: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.paymentMethod = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.paymentMethod = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.paymentMethod = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
